export const SHOW_DESCRIPTION = true
export const NAME_DISPLAY_MODEL: 'inline' | 'flex' = 'flex'
export const HAS_PADDING = true
